/**
 * Definitions for BE managed types are defined here.
 *
 * Add more when new APIs are implemented. Also modify existing models when BE updates their schema.
 */
export { AdditionRewards } from '@wolffun/shared/src/models';
export let SearchParamsSortOption;

(function (SearchParamsSortOption) {
  SearchParamsSortOption["ID_ASC"] = "IdAsc";
  SearchParamsSortOption["ID_DESC"] = "IdDesc";
  SearchParamsSortOption["PRICE_ASC"] = "PriceAsc";
  SearchParamsSortOption["PRICE_DESC"] = "PriceDesc";
  SearchParamsSortOption["LATEST"] = "Latest";
  SearchParamsSortOption["OLDEST"] = "Oldest";
  SearchParamsSortOption["PRICE_PER_BATTLES"] = "PPB";
  SearchParamsSortOption["HERO_RARITY"] = "hr";
  SearchParamsSortOption["GTHC_BATTLES"] = "gthcb";
  SearchParamsSortOption["TROPHY_CLASS"] = "tc";
  SearchParamsSortOption["LEVEL"] = "lv";
})(SearchParamsSortOption || (SearchParamsSortOption = {}));

export let SaleBidStatus;

(function (SaleBidStatus) {
  SaleBidStatus[SaleBidStatus["COMPLETED"] = 10] = "COMPLETED";
  SaleBidStatus[SaleBidStatus["TRANSACTION_IN_PROCESS"] = 20] = "TRANSACTION_IN_PROCESS";
  SaleBidStatus[SaleBidStatus["FAILED"] = 99] = "FAILED";
})(SaleBidStatus || (SaleBidStatus = {}));

export let StakingPlan;

(function (StakingPlan) {
  StakingPlan[StakingPlan["FLEXIBLE"] = 1] = "FLEXIBLE";
  StakingPlan[StakingPlan["SIX_MONTHS"] = 2] = "SIX_MONTHS";
  StakingPlan[StakingPlan["ONE_YEAR"] = 3] = "ONE_YEAR";
})(StakingPlan || (StakingPlan = {}));

export let StakingStatus;

(function (StakingStatus) {
  StakingStatus[StakingStatus["PENDING"] = 1] = "PENDING";
  StakingStatus[StakingStatus["TIMEOUT"] = 2] = "TIMEOUT";
  StakingStatus[StakingStatus["VERIFIED"] = 3] = "VERIFIED";
  StakingStatus[StakingStatus["UNSTAKE_VERIFIED"] = 4] = "UNSTAKE_VERIFIED";
})(StakingStatus || (StakingStatus = {}));

export let CosmeticEventSource;

(function (CosmeticEventSource) {
  CosmeticEventSource[CosmeticEventSource["OPEN_BOX"] = 1] = "OPEN_BOX";
  CosmeticEventSource[CosmeticEventSource["SEASON_END"] = 2] = "SEASON_END";
  CosmeticEventSource[CosmeticEventSource["RANKING_REWARD"] = 3] = "RANKING_REWARD";
  CosmeticEventSource[CosmeticEventSource["SOLD"] = 4] = "SOLD";
  CosmeticEventSource[CosmeticEventSource["PURCHASED"] = 5] = "PURCHASED";
  CosmeticEventSource[CosmeticEventSource["MINT"] = 6] = "MINT";
})(CosmeticEventSource || (CosmeticEventSource = {}));

export let IngameMode;

(function (IngameMode) {
  IngameMode[IngameMode["TEAM_COLLECT_STAR"] = 0] = "TEAM_COLLECT_STAR";
  IngameMode[IngameMode["SOLO_SURVIVAL"] = 1] = "SOLO_SURVIVAL";
  IngameMode[IngameMode["DUAL_SURVIVAL"] = 2] = "DUAL_SURVIVAL";
  IngameMode[IngameMode["TEAM_COLLECT_STAR_4_VS_4"] = 3] = "TEAM_COLLECT_STAR_4_VS_4";
  IngameMode[IngameMode["KING"] = 5] = "KING";
  IngameMode[IngameMode["DEATH_MATCH"] = 6] = "DEATH_MATCH";
  IngameMode[IngameMode["DEATH_MATCH_3_VS_3"] = 7] = "DEATH_MATCH_3_VS_3";
  IngameMode[IngameMode["FLAG"] = 8] = "FLAG";
  IngameMode[IngameMode["TOWER"] = 9] = "TOWER";
  IngameMode[IngameMode["TRY_HERO_SKILL_MODE"] = 99] = "TRY_HERO_SKILL_MODE";
  IngameMode[IngameMode["NONE"] = 100] = "NONE";
  IngameMode[IngameMode["TUTORIAL"] = 254] = "TUTORIAL";
})(IngameMode || (IngameMode = {}));

export let BattleResult;

(function (BattleResult) {
  BattleResult[BattleResult["LOSE"] = -1] = "LOSE";
  BattleResult[BattleResult["DRAW"] = 0] = "DRAW";
  BattleResult[BattleResult["VICTORY"] = 1] = "VICTORY";
})(BattleResult || (BattleResult = {}));

export let CreatorCornerTab;

(function (CreatorCornerTab) {
  CreatorCornerTab["Creator"] = "creator";
  CreatorCornerTab["Viewer"] = "viewer";
})(CreatorCornerTab || (CreatorCornerTab = {}));

export let QuestClaimStatus;

(function (QuestClaimStatus) {
  QuestClaimStatus[QuestClaimStatus["CAN_CLAIM"] = 0] = "CAN_CLAIM";
  QuestClaimStatus[QuestClaimStatus["PROCESSING"] = 1] = "PROCESSING";
  QuestClaimStatus[QuestClaimStatus["CLAIMED"] = 2] = "CLAIMED";
  QuestClaimStatus[QuestClaimStatus["ERROR"] = 3] = "ERROR";
})(QuestClaimStatus || (QuestClaimStatus = {}));

export let QuestBoxItemType;

(function (QuestBoxItemType) {
  QuestBoxItemType[QuestBoxItemType["COMMON_HERO"] = 9] = "COMMON_HERO";
  QuestBoxItemType[QuestBoxItemType["EPIC_HERO"] = 17] = "EPIC_HERO";
  QuestBoxItemType[QuestBoxItemType["LEGENDARY_HERO"] = 33] = "LEGENDARY_HERO";
  QuestBoxItemType[QuestBoxItemType["COSMETIC"] = 10] = "COSMETIC";
  QuestBoxItemType[QuestBoxItemType["GTHC"] = 516] = "GTHC";
})(QuestBoxItemType || (QuestBoxItemType = {}));

export let FusionStatus;

(function (FusionStatus) {
  FusionStatus[FusionStatus["AVAILABLE"] = 0] = "AVAILABLE";
  FusionStatus[FusionStatus["PROCESSING"] = 1] = "PROCESSING";
})(FusionStatus || (FusionStatus = {}));

export let GroupCount;

(function (GroupCount) {
  GroupCount["Time_24_hours"] = "1";
  GroupCount["Time_7_days"] = "2";
  GroupCount["Time_30_days"] = "3";
  GroupCount["Time_All"] = "4";
})(GroupCount || (GroupCount = {}));

export let MKPRefType;

(function (MKPRefType) {
  MKPRefType[MKPRefType["HERO"] = 0] = "HERO";
  MKPRefType[MKPRefType["PET"] = 1] = "PET";
  MKPRefType[MKPRefType["COSMETIC"] = 2] = "COSMETIC";
  MKPRefType[MKPRefType["BOX"] = 3] = "BOX";
  MKPRefType[MKPRefType["FUSION"] = 4] = "FUSION";
  MKPRefType[MKPRefType["PRIVATE_SALE"] = 5] = "PRIVATE_SALE";
  MKPRefType[MKPRefType["TICKET_BATTLE"] = 6] = "TICKET_BATTLE";
  MKPRefType[MKPRefType["NONE"] = 7] = "NONE";
})(MKPRefType || (MKPRefType = {}));

export let DailyQuestType;

(function (DailyQuestType) {
  DailyQuestType[DailyQuestType["SELLER"] = 1] = "SELLER";
  DailyQuestType[DailyQuestType["UNBOX"] = 2] = "UNBOX";
})(DailyQuestType || (DailyQuestType = {}));

export let ClaimStatus;

(function (ClaimStatus) {
  ClaimStatus[ClaimStatus["LOCK"] = 0] = "LOCK";
  ClaimStatus[ClaimStatus["CAN_NOT"] = 1] = "CAN_NOT";
  ClaimStatus[ClaimStatus["CAN"] = 2] = "CAN";
  ClaimStatus[ClaimStatus["CLAIMED"] = 3] = "CLAIMED";
})(ClaimStatus || (ClaimStatus = {}));

export let MKPTab;

(function (MKPTab) {
  MKPTab[MKPTab["Dashboard"] = 1] = "Dashboard";
  MKPTab[MKPTab["ThetanBox"] = 2] = "ThetanBox";
  MKPTab[MKPTab["Buy"] = 3] = "Buy";
  MKPTab[MKPTab["Rent"] = 4] = "Rent";
  MKPTab[MKPTab["SpecialEvent"] = 5] = "SpecialEvent";
  MKPTab[MKPTab["Staking"] = 6] = "Staking";
  MKPTab[MKPTab["MKPQuest"] = 7] = "MKPQuest";
  MKPTab[MKPTab["ConvertionProgram"] = 8] = "ConvertionProgram";
  MKPTab[MKPTab["VestingSafe"] = 9] = "VestingSafe";
  MKPTab[MKPTab["CreatorCorner"] = 10] = "CreatorCorner";
})(MKPTab || (MKPTab = {}));

export let CallOutType;

(function (CallOutType) {
  CallOutType[CallOutType["FusionLeaderboard"] = 1] = "FusionLeaderboard";
  CallOutType[CallOutType["TournamentLeaderboard"] = 2] = "TournamentLeaderboard";
  CallOutType[CallOutType["HeroTradingLeaderboard"] = 3] = "HeroTradingLeaderboard";
  CallOutType[CallOutType["QuestCompetition"] = 4] = "QuestCompetition";
  CallOutType[CallOutType["NoName"] = 5] = "NoName";
  CallOutType[CallOutType["SpecialBox"] = 6] = "SpecialBox";
  CallOutType[CallOutType["FusionLive"] = 7] = "FusionLive";
  CallOutType[CallOutType["TradingEventLive"] = 8] = "TradingEventLive";
  CallOutType[CallOutType["TournamentLive"] = 9] = "TournamentLive";
  CallOutType[CallOutType["MKPSingleQuest"] = 10] = "MKPSingleQuest";
  CallOutType[CallOutType["QuestStageComplete"] = 11] = "QuestStageComplete";
  CallOutType[CallOutType["DailyLoginReward"] = 12] = "DailyLoginReward";
  CallOutType[CallOutType["SuccessSellItem"] = 13] = "SuccessSellItem";
  CallOutType[CallOutType["SuccessRentoutItem"] = 14] = "SuccessRentoutItem";
  CallOutType[CallOutType["TradingEventChallenge"] = 15] = "TradingEventChallenge";
})(CallOutType || (CallOutType = {}));

export let ClaimTicketStatus;

(function (ClaimTicketStatus) {
  ClaimTicketStatus["AVAILABLE"] = "Available";
  ClaimTicketStatus["PROCESSING"] = "Processing";
  ClaimTicketStatus["ERROR"] = "Error";
})(ClaimTicketStatus || (ClaimTicketStatus = {}));

export let RewardType;

(function (RewardType) {
  RewardType["HERO"] = "Hero";
  RewardType["COSMETIC"] = "Cosmetic";
  RewardType["GTHG"] = "THG";
  RewardType["POWERPOINT"] = "PP";
  RewardType["BUSD"] = "BUSD";
  RewardType["TANGIBLE"] = "Tangible";
  RewardType["LOGO"] = "Logo";
  RewardType["GREETING"] = "Greeting";
  RewardType["BNBGIFTCARD"] = "BinanceGiftCard";
})(RewardType || (RewardType = {}));

export let TangibleType;

(function (TangibleType) {
  TangibleType[TangibleType["IPAD_AIR"] = 1] = "IPAD_AIR";
  TangibleType[TangibleType["NINTENDO"] = 2] = "NINTENDO";
  TangibleType[TangibleType["RAZER_KEYBOARD"] = 3] = "RAZER_KEYBOARD";
  TangibleType[TangibleType["RAZER_HEADSET"] = 4] = "RAZER_HEADSET";
  TangibleType[TangibleType["RAZER_MOUSE"] = 5] = "RAZER_MOUSE";
})(TangibleType || (TangibleType = {}));

export let LogoType;

(function (LogoType) {
  LogoType[LogoType["THETAN_RIVAL"] = 1] = "THETAN_RIVAL";
  LogoType[LogoType["THETAN_ARENA"] = 2] = "THETAN_ARENA";
  LogoType[LogoType["SEQUENCE"] = 3] = "SEQUENCE";
})(LogoType || (LogoType = {}));

export let TangibleName;

(function (TangibleName) {
  TangibleName["IPAD_AIR"] = "Ipad Air";
  TangibleName["NINTENDO"] = "Nintendo Switch";
  TangibleName["RAZER_KEYBOARD"] = "Razer Keyboard";
  TangibleName["RAZER_HEADSET"] = "Razer Headset";
  TangibleName["RAZER_MOUSE"] = "Razer Mouse";
})(TangibleName || (TangibleName = {}));

export let GiftmasQuestType;

(function (GiftmasQuestType) {
  GiftmasQuestType["DAILY"] = "DailyCheckin";
  GiftmasQuestType["SEQUENCE"] = "Sequence";
  GiftmasQuestType["FRIEND_SEQUENCE"] = "FriendSequence";
  GiftmasQuestType["CHRISTMAS_BOX"] = "Christmas";
  GiftmasQuestType["OTHER_WALLET"] = "Wallet";
})(GiftmasQuestType || (GiftmasQuestType = {}));

export let ClaimLimitType;

(function (ClaimLimitType) {
  ClaimLimitType["DAILY"] = "Daily";
  ClaimLimitType["WEEKLY"] = "Weekly";
  ClaimLimitType["TIMES"] = "Times";
})(ClaimLimitType || (ClaimLimitType = {}));

export let WheelType;

(function (WheelType) {
  WheelType["Wheel1"] = "Wheel1";
})(WheelType || (WheelType = {}));